import { discardItemsWithEmptyValues } from '@/helpers/object';

export default {
  canvasSelectedQuestion(state) {
    const questionId = state.canvasSelectedQuestionId;
    const question = state.canvasQuestions.find(q => q.id === questionId);
    return question;
  },

  canvasParsedQuestions(state) {
    const conditionals = state.canvasQuestions
      .filter(q => q.visibilityCondition && q.visibilityCondition !== '')
      .reduce((acc, q) => {
        const regexp = /{question([\d]+)}=['"]([^']+)['"]/g;
        const matches = q.visibilityCondition.matchAll(regexp);
        const parsed = [...matches].map(match => ({
          link: q.id,
          questionId: parseInt(match[1], 10),
          choiceTitle: match[2],
        }));

        return [...acc, ...parsed];
      }, []);

    const updatedQuestions = state.canvasQuestions.map(question => {
      const choices = (question.choices || []).map(choice => {
        const conditional = conditionals.find(
          c => c.questionId === question.id && c.choiceTitle === choice.title,
        );

        if (!conditional) {
          return choice;
        }

        return { ...choice, conditionalLink: conditional.link };
      });

      return { ...question, choices };
    });
    return updatedQuestions;
  },

  selectorQuestionFilters(state) {
    return discardItemsWithEmptyValues({
      filter: state.selectorQuestionSearchText,
      categoryId: state.selectorSelectedQuestionCategory,
    });
  },

  selectorChoiceFilters(state) {
    return discardItemsWithEmptyValues({
      filter: state.selectorChoiceSearchText,
      categoryId: state.selectorSelectedChoiceCategory,
    });
  },

  selectorChoiceTemplateFilters(state) {
    return discardItemsWithEmptyValues({
      filter: state.selectorTemplateSearchText,
      categoryId: state.selectorSelectedTemplateCategory,
    });
  },

  selectorHookFilters(state) {
    return discardItemsWithEmptyValues({
      filter: state.selectorHookSearchText,
    });
  },

  selectorMatrixChoiceFilters(state) {
    return discardItemsWithEmptyValues({
      filter: state.selectorMatrixChoiceSearchText,
    });
  },

  selectorDisabledQuestionIds(state) {
    return state.canvasQuestions.map(q => q.id);
  },

  selectorDisabledTemplateIds(state, getters) {
    const selectedQuestion = getters.canvasSelectedQuestion;
    const choices = selectedQuestion && selectedQuestion.choices ? selectedQuestion.choices : [];
    return choices.map(c => c.templateId);
  },

  selectorDisabledChoiceIds(state, getters) {
    const selectedQuestion = getters.canvasSelectedQuestion;
    const choices = selectedQuestion && selectedQuestion.choices ? selectedQuestion.choices : [];
    return choices.map(c => c.id);
  },

  hookQuestions(state) {
    return state.hookList.map(hook => ({
      title: hook.title,
      questionType: 'MEDIA',
      chart: '',
      categoryId: null,
      insight: '',
      isRequired: true,
      isGlobal: false,
      isProfile: false,
      profileField: null,
      isChoiceOrderReversed: false,
      visibilityCondition: '',
      mediaClip: hook,
      choices: [],
      matrixChoices: [],
    }));
  },

  matrixChoices(state) {
    const groupMediaQuestion = state.canvasQuestions.find(q => q.questionType === 'MEDIA');
    if (!groupMediaQuestion) {
      return [];
    }
    return groupMediaQuestion.matrixChoices || [];
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/surveybuilder/getters.js